export default __webpack_public_path__ + "static/media/SecludedCove.d2ba92ec.jpg";